/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConnectionCheckDto } from '../models';
// @ts-ignore
import type { JainIntegrationDto } from '../models';
// @ts-ignore
import type { MediaIntegrationDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
export const IntegrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CONFIGURATION — the address, the identity provider, the client and its secret are set. TOKEN — the identity provider jAIn trusts issues a token to the client, and the token carries the role jAIn admits Ankieter with (ankieter-sync). JAIN — jAIn answers the request for the positions with that token. Takes up to a few seconds per step when something does not answer.
         * @summary Check the connection to jAIn, step by step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJainIntegration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/jain/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CONFIGURATION — the address, the bucket and the region are set. WRITE — a small probe file goes into the bucket; wrong keys, a missing bucket or a wrong region stop here. LINK — a signed link to it, made for the address browsers use, gives the same bytes back: the only step that shows a link signed for an address the store does not answer to. DELETE — the probe file is removed, whenever writing it worked.
         * @summary Check the media store, step by step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMediaIntegration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/media/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Addresses and the client the connection uses. The client secret is never part of it, nor whether one is set beyond what configured says.
         * @summary The connection to jAIn, as configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJainIntegration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/jain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Where the store is and which bucket holds the files. Never the keys.
         * @summary The media store, as configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaIntegration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationsApi - functional programming interface
 * @export
 */
export const IntegrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * CONFIGURATION — the address, the identity provider, the client and its secret are set. TOKEN — the identity provider jAIn trusts issues a token to the client, and the token carries the role jAIn admits Ankieter with (ankieter-sync). JAIN — jAIn answers the request for the positions with that token. Takes up to a few seconds per step when something does not answer.
         * @summary Check the connection to jAIn, step by step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkJainIntegration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkJainIntegration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.checkJainIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CONFIGURATION — the address, the bucket and the region are set. WRITE — a small probe file goes into the bucket; wrong keys, a missing bucket or a wrong region stop here. LINK — a signed link to it, made for the address browsers use, gives the same bytes back: the only step that shows a link signed for an address the store does not answer to. DELETE — the probe file is removed, whenever writing it worked.
         * @summary Check the media store, step by step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMediaIntegration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMediaIntegration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.checkMediaIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Addresses and the client the connection uses. The client secret is never part of it, nor whether one is set beyond what configured says.
         * @summary The connection to jAIn, as configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJainIntegration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JainIntegrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJainIntegration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getJainIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Where the store is and which bucket holds the files. Never the keys.
         * @summary The media store, as configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaIntegration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaIntegrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaIntegration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationsApi.getMediaIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationsApi - factory interface
 * @export
 */
export const IntegrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationsApiFp(configuration)
    return {
        /**
         * CONFIGURATION — the address, the identity provider, the client and its secret are set. TOKEN — the identity provider jAIn trusts issues a token to the client, and the token carries the role jAIn admits Ankieter with (ankieter-sync). JAIN — jAIn answers the request for the positions with that token. Takes up to a few seconds per step when something does not answer.
         * @summary Check the connection to jAIn, step by step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJainIntegration(options?: RawAxiosRequestConfig): AxiosPromise<ConnectionCheckDto> {
            return localVarFp.checkJainIntegration(options).then((request) => request(axios, basePath));
        },
        /**
         * CONFIGURATION — the address, the bucket and the region are set. WRITE — a small probe file goes into the bucket; wrong keys, a missing bucket or a wrong region stop here. LINK — a signed link to it, made for the address browsers use, gives the same bytes back: the only step that shows a link signed for an address the store does not answer to. DELETE — the probe file is removed, whenever writing it worked.
         * @summary Check the media store, step by step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMediaIntegration(options?: RawAxiosRequestConfig): AxiosPromise<ConnectionCheckDto> {
            return localVarFp.checkMediaIntegration(options).then((request) => request(axios, basePath));
        },
        /**
         * Addresses and the client the connection uses. The client secret is never part of it, nor whether one is set beyond what configured says.
         * @summary The connection to jAIn, as configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJainIntegration(options?: RawAxiosRequestConfig): AxiosPromise<JainIntegrationDto> {
            return localVarFp.getJainIntegration(options).then((request) => request(axios, basePath));
        },
        /**
         * Where the store is and which bucket holds the files. Never the keys.
         * @summary The media store, as configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaIntegration(options?: RawAxiosRequestConfig): AxiosPromise<MediaIntegrationDto> {
            return localVarFp.getMediaIntegration(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationsApi - interface
 * @export
 * @interface IntegrationsApi
 */
export interface IntegrationsApiInterface {
    /**
     * CONFIGURATION — the address, the identity provider, the client and its secret are set. TOKEN — the identity provider jAIn trusts issues a token to the client, and the token carries the role jAIn admits Ankieter with (ankieter-sync). JAIN — jAIn answers the request for the positions with that token. Takes up to a few seconds per step when something does not answer.
     * @summary Check the connection to jAIn, step by step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiInterface
     */
    checkJainIntegration(options?: RawAxiosRequestConfig): AxiosPromise<ConnectionCheckDto>;

    /**
     * CONFIGURATION — the address, the bucket and the region are set. WRITE — a small probe file goes into the bucket; wrong keys, a missing bucket or a wrong region stop here. LINK — a signed link to it, made for the address browsers use, gives the same bytes back: the only step that shows a link signed for an address the store does not answer to. DELETE — the probe file is removed, whenever writing it worked.
     * @summary Check the media store, step by step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiInterface
     */
    checkMediaIntegration(options?: RawAxiosRequestConfig): AxiosPromise<ConnectionCheckDto>;

    /**
     * Addresses and the client the connection uses. The client secret is never part of it, nor whether one is set beyond what configured says.
     * @summary The connection to jAIn, as configured
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiInterface
     */
    getJainIntegration(options?: RawAxiosRequestConfig): AxiosPromise<JainIntegrationDto>;

    /**
     * Where the store is and which bucket holds the files. Never the keys.
     * @summary The media store, as configured
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApiInterface
     */
    getMediaIntegration(options?: RawAxiosRequestConfig): AxiosPromise<MediaIntegrationDto>;

}

/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
export class IntegrationsApi extends BaseAPI implements IntegrationsApiInterface {
    /**
     * CONFIGURATION — the address, the identity provider, the client and its secret are set. TOKEN — the identity provider jAIn trusts issues a token to the client, and the token carries the role jAIn admits Ankieter with (ankieter-sync). JAIN — jAIn answers the request for the positions with that token. Takes up to a few seconds per step when something does not answer.
     * @summary Check the connection to jAIn, step by step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public checkJainIntegration(options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).checkJainIntegration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CONFIGURATION — the address, the bucket and the region are set. WRITE — a small probe file goes into the bucket; wrong keys, a missing bucket or a wrong region stop here. LINK — a signed link to it, made for the address browsers use, gives the same bytes back: the only step that shows a link signed for an address the store does not answer to. DELETE — the probe file is removed, whenever writing it worked.
     * @summary Check the media store, step by step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public checkMediaIntegration(options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).checkMediaIntegration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Addresses and the client the connection uses. The client secret is never part of it, nor whether one is set beyond what configured says.
     * @summary The connection to jAIn, as configured
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getJainIntegration(options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getJainIntegration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Where the store is and which bucket holds the files. Never the keys.
     * @summary The media store, as configured
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public getMediaIntegration(options?: RawAxiosRequestConfig) {
        return IntegrationsApiFp(this.configuration).getMediaIntegration(options).then((request) => request(this.axios, this.basePath));
    }
}

